import { attributionProps, captureAttributionFromLocation, getAttribution } from "./attribution";
import { emitLaunchFunnelEvent } from "./api";
import { trackPlausibleEvent } from "./plausible";

const VISIT_ONCE_KEY = "minuta.launch.visit.once";
const SIGNUP_ONCE_PREFIX = "minuta.launch.signup";
const PAID_ONCE_PREFIX = "minuta.launch.paid";

function trackOnce(storageKey: string, fn: () => void): void {
  try {
    if (sessionStorage.getItem(storageKey) === "1") return;
    sessionStorage.setItem(storageKey, "1");
  } catch {
    // If storage is unavailable, fire best-effort.
  }
  fn();
}

function distinctId(): string {
  try {
    const key = "minuta.launch.distinct_id";
    const existing = localStorage.getItem(key);
    if (existing && existing.trim()) return existing;
    const created = crypto.randomUUID();
    localStorage.setItem(key, created);
    return created;
  } catch {
    return crypto.randomUUID();
  }
}

function send(event: "launch_visit" | "launch_signup" | "launch_paid" | "desktop_download_clicked", action?: string): void {
  const attr = getAttribution();
  void emitLaunchFunnelEvent({
    event,
    distinctId: distinctId(),
    source: attr.source,
    channel: attr.channel,
    campaign: attr.campaign,
    content: attr.content,
    app: "site",
    path: window.location.pathname,
    action,
  }).catch(() => {});
}

export function trackLaunchVisit(): void {
  captureAttributionFromLocation();
  trackOnce(VISIT_ONCE_KEY, () => {
    trackPlausibleEvent("launch_visit", attributionProps());
    send("launch_visit");
  });
}

export function trackLaunchSignupOnce(scope: string): void {
  trackOnce(`${SIGNUP_ONCE_PREFIX}.${scope}`, () => {
    trackPlausibleEvent("launch_signup", attributionProps());
    send("launch_signup");
  });
}

export function trackLaunchPaidOnce(scope: string): void {
  trackOnce(`${PAID_ONCE_PREFIX}.${scope}`, () => {
    trackPlausibleEvent("launch_paid", attributionProps());
    send("launch_paid");
  });
}

export function trackDesktopDownloadClicked(action: string): void {
  captureAttributionFromLocation();
  send("desktop_download_clicked", action);
}
